import React, {useCallback} from 'react';
import {useParams} from 'react-router-dom';


import {SearchTemplateUserController} from 'src/components/search-template-user';
import {ReplaceSearchesSettings} from 'src/modules/profile/user/components/replace-search-settings';

import FormSection from '@pb/kit-component-form-section';

import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    selectedTemplateUserId: number | null,
    setSelectedTemplateUserId: (id: number | null) => void,
    savedSearches: boolean,
    templates: boolean,
    emailAlerts: boolean,
    setEmailAlerts: (data: boolean) => void,
    setTemplates: (data: boolean) => void,
    setSavedSearches: (data: boolean) => void,
    onFieldChange: (fieldName: string) => void,
};

export const ImportSettings: React.FC<Props> = props => {
    const {
        setSelectedTemplateUserId,
        savedSearches,
        setEmailAlerts,
        emailAlerts,
        templates,
        setTemplates,
        setSavedSearches,
        onFieldChange,
        selectedTemplateUserId,
    } = props;

    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : -1;

    const onSelectTemplateUser = useCallback((account: UserShortInfo | undefined) => {
        setSelectedTemplateUserId(account?.userId || null);
    }, [setSelectedTemplateUserId]);

    return (
        <FormSection headline="Import Options">
            <SearchTemplateUserController
                accountId={accountId}
                onSelect={onSelectTemplateUser}
                onFieldChange={onFieldChange}
            />
            <ReplaceSearchesSettings {...{
                savedSearches,
                setEmailAlerts,
                emailAlerts,
                templates,
                setTemplates,
                setSavedSearches,
                selectedTemplateUserId,
                onFieldChange,
            }}
            />
        </FormSection>
    );
};
